import s12 from "../assets/medical.png";

export const MEDICALCODING_SYLLABUS_DATA = [
{
    id: "medicalcoding-1",
    title: "Medical Coding ",
    hours: "30 hrs",
    image: s12,
modules: [
  "Business of Medicine",
  "Anatomy, Physiology & Pathology",
  "ICD-10-CM Navigation, convention, General Coding Guidelines",
  "ICD-10-CM Chapter specific guidelines 1-11",
  "ICD-10-CM Chapter specific guidelines 12-22",
  "CPT Navigation & Guidelines",
  "Surgery (Integumentary systems)",
  "AAPC Guidelines",
  "HCPCS Guidelines",
  "RCM and Coding Compliance",
]
  },

];